/** 스켈레톤 리스트 블록 수 — Figma 8306-16562 '화면을 불러오는중' (320×48 × 11) */
const SKELETON_LIST_COUNT = 11

/**
 * 모두의 차고 상세 로딩 스켈레톤 (Figma 8306-16562)
 * SSR 데이터 조회(스트리밍) 동안, 그리고 에러 화면에서 '다시 시도하기' 재요청 동안 노출.
 * 타이틀(200×36)+설명(120×24) + 리스트 블록.
 */
const ModoocarSkeleton = () => {
  return (
    <div className='mx-auto w-full max-w-[640px] animate-pulse px-dimension-x5 py-dimension-x5'>
      {/* Heading — 타이틀/설명 자리 */}
      <div className='flex flex-col gap-dimension-x2'>
        <div className='h-9 w-[200px] rounded-[10px] bg-background-neutral-weak' />
        <div className='h-6 w-[120px] rounded-[10px] bg-background-neutral-weak' />
      </div>

      {/* List — 콘텐츠 블록 자리 */}
      <div className='flex flex-col gap-dimension-x4 pt-dimension-x6'>
        {Array.from({ length: SKELETON_LIST_COUNT }, (_, index) => (
          <div
            key={index}
            className='h-12 w-full rounded-[10px] bg-background-neutral-weak'
          />
        ))}
      </div>
    </div>
  )
}

export default ModoocarSkeleton
